import React, { useContext } from "react";
import { AppContext } from "../context/AppContextProvider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

const HaqtProfileMenu = () => {
  const { user, setUser } = useContext(AppContext);
  const navigate = useNavigate();

  const [anchorUserMenuEl, setAnchorUserMenuEl] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorUserMenuEl(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorUserMenuEl(null);
  };
  const handleLogout = () => {
    navigate("/auth/login");
    sessionStorage.clear();
    setUser({});
  };

  return (
    <>
      <Tooltip title="Open Settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            alt={user.userName}
            src={user.profilePicturePath}
            sx={{
              backgroundColor: "#0A6073",
              height: "30px",
              width: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "22px",
            }}
          >
            {user.userName ? user.userName[0].toUpperCase() : null}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        // id="menu-appbar"
        anchorEl={anchorUserMenuEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorUserMenuEl)}
        onClose={handleCloseUserMenu}
        getContentAnchorEl={null}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>Log Out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default HaqtProfileMenu;
